import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EmailNotificationModel, EmailNotificationPDFModel, GenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel, BasicApiResponseModel  } from '../../shared';
import { BaseGenDocTypeService } from './base-generic-doc-hdr.service';
import { GenericDocumentPutDTO } from '../../../data-transfer-objects';

@Injectable({
  providedIn: 'root'
})
export class InternalSalesCreditNoteService extends BaseGenDocTypeService {

  constructor(http: HttpClient) {
    super(http, 'internal-sales-credit-notes');
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-sales-credit-notes';
    this.httpClient = http;
  }

  getLinesByCriteria(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<GenericDocContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  getLinesByCriteriaPromise(pagination: Pagination, visa: ApiVisa): Promise<PagingResponseModel<GenericDocContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(UrlByCriteria, this.getHttpHeader(visa)).toPromise();
  }

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string): Observable<Blob> {
    let params;
    let url;
    if (customParam) {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid)
        .set('customParam', customParam);
    } else {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid);
    }

    url = apiVisa.api_domain_url + this.endpoint_path + "/print-jasper-pdf/" + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

  public getAttachmentFile(extensionGuid: string, apiVisa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + '/file/' + extensionGuid,
      this.getHttpHeaderBlob(apiVisa)
    );
  }

  discardGenericDocument(apiVisa: ApiVisa, guid: string) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<ApiResponseModel<GenericDocContainerModel>>(
      this.apiUrl + '/discard/backoffice-ep/' + guid,
      null, //empty body
      this.getHttpHeader(apiVisa)
    );
  }

  sendEmailNotification(
    guid,
    dtoObject: EmailNotificationModel,
    visa: ApiVisa
  ) {
    let url;

    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        this.endpoint_path +
        "/email-notification/backoffice-ep/" +
        guid;
    }

    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  sendEmailPDF(
    guid,
    dtoObject: EmailNotificationPDFModel,
    visa: ApiVisa
  ) {
    let url;

    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        this.endpoint_path +
        "/send-email-pdf/backoffice-ep/" +
        guid;
    }

    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }
  
  updateWithParams(dto: GenericDocumentPutDTO, genDocCon: any, visa: ApiVisa) {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/with-params?generateTrackingId=" + dto.generateTrackingId + "&trackingIdPrefix=" + dto.trackingIdPrefix;
    }
    return this.httpClient.put<BasicApiResponseModel<GenericDocContainerModel>>(
      url, 
      genDocCon,
      this.getHttpHeader(visa)
    );
  }
}
